import styled, { css } from 'styled-components'

import {
  _M_Bold,
  _S_Normal,
  _XS_Normal,
  ellipsis,
  mainColors,
  rgba,
  riskChannelsColors,
  semanticColors,
} from '@avantstay/backoffice-core'

import { NotificationCategory } from '../../OperationsNotification.types'

const categoryAccentColors: Record<NotificationCategory, string> = {
  [NotificationCategory.mention]: semanticColors.failureMedium,
  [NotificationCategory.case]: mainColors.accentMedium,
  [NotificationCategory.other]: mainColors.neutralDark,
}

export const CardContainer = styled.div<{ hasLink: boolean; category: NotificationCategory }>`
  display: flex;
  flex-direction: column;
  padding: 12px;
  padding-left: 10px;
  border: 1px solid ${mainColors.neutralMedium};
  border-left: 3px solid ${mainColors.neutralDark};
  border-radius: 8px;
  box-sizing: border-box;
  transition: border-left-color 0.15s ease;

  ${({ hasLink, category }) =>
    hasLink &&
    css`
      &:hover {
        cursor: pointer;
        border-color: ${mainColors.neutralDark};
        border-left: 3px solid ${categoryAccentColors[category]};
        box-shadow: 0 4px 50px 0 ${rgba(riskChannelsColors.channelMobile, 0.1)};
      }
    `}

  ${({ hasLink, category }) =>
    !hasLink &&
    css`
      &:hover {
        border-left-color: ${categoryAccentColors[category]};
      }
    `}
`

export const CardHeader = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  width: 100%;
  gap: 8px;
  margin-bottom: 8px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  background-color: ${mainColors.neutralExtraLight2};
  color: ${mainColors.neutralExtraDark};
`

export const TitleText = styled.p`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  ${ellipsis};
`

export const DateText = styled.span`
  ${_XS_Normal};
  color: ${mainColors.neutralExtremelyDark};
`

export const UnreadDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${semanticColors.failureMedium};
`

export const Subject = styled.p`
  ${_M_Bold};
  color: ${mainColors.black};
  line-height: 20px;
  ${ellipsis};
  margin-bottom: 8px;
`

export const HomeNameWrapper = styled.div`
  & > div {
    line-height: 20px;
    ${_S_Normal};
    color: ${mainColors.neutralExtremelyDark};
  }
`
